import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import UsersService from "@services/UsersService";

export const getReps = createAsyncThunk(
  "user/reps",
  async (_, {rejectWithValue}) => {
    try {
      const response = await UsersService.getReps();

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const getManagers = createAsyncThunk(
  "user/managers",
  async (_, {rejectWithValue}) => {
    try {
      const response = await UsersService.getManagers();

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const getWeeklyActivity = createAsyncThunk(
  "user/weekly-activity",
  async (id, {rejectWithValue}) => {
    try {
      const response = await UsersService.getWeeklyActivity({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  reps: [],
  managers: [],
  weeklyActivity: {},
  errors: null,
  error: "",
  status: "",
};

const userOptionsSlice = createSlice({
  name: "user-options",
  initialState,
  reducers: {
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearOptions() {
      return initialState;
    },
    clearWeeklyActivity(state) {
      return {
        ...state,
        weeklyActivity: {},
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReps.pending, (state) => {
        pendingState(state);
      })
      .addCase(getReps.fulfilled, (state, action) => {
        state.reps = action.payload;
        fulfilledState(state);
      })
      .addCase(getReps.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(getManagers.pending, (state) => {
        pendingState(state);
      })
      .addCase(getManagers.fulfilled, (state, action) => {
        state.managers = action.payload;
        fulfilledState(state);
      })
      .addCase(getManagers.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(getWeeklyActivity.pending, (state) => {
        pendingState(state);
      })
      .addCase(getWeeklyActivity.fulfilled, (state, action) => {
        state.weeklyActivity = action.payload;
        fulfilledState(state);
      })
      .addCase(getWeeklyActivity.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {setError, setStatus, clearOptions, clearWeeklyActivity} =
  userOptionsSlice.actions;
export default userOptionsSlice.reducer;
